<template>
  <div class="p-management-salon-item-content w-100 row">
      <div class="p-management-salon-items pr-4 pl-4 w-100 row">
              <div v-for="data in allSans" :key="data.id" class="p-management-salon-item row">

                    <div class="w-100 d-flex p-management-salon-header justify-content-center align-items-center">
                        <div class="row">
                            <h3 class="p-management-salon-title ml-2">شروع</h3>
                            <h3 class=" p-management-salon-title p-management-salon-time-title ml-2">
                              {{data.start_time}}
                            </h3>
                        </div>
                        <div class="row">
                            <h3 class="p-management-salon-title ml-2">پایان </h3>
                            <h3 class=" p-management-salon-title p-management-salon-time-title ml-2">
                              {{data.end_time}}
                            </h3>
                        </div>
                    </div>

                    <div class="w-100 d-flex p-management-salon-btns justify-content-center align-items-center">
                        <button @click="deleteSans(data)" type="button" class="d-flex flex-wrap p-management-delete-btn btn btn-primary btn-red remove-radius ml-4 align-items-center p-management-btn">
                          <h3 class="p-management-delete-title">حذف</h3>
                          <img class="p-management-salon-icon" src="../../assets/svg/management-delete-icon.svg" alt="">
                        </button>
                        <button @click="editSans(data)" type="button" class="d-flex flex-wrap p-management-delete-btn btn btn-primary btn-red remove-radius ml-4 align-items-center p-management-btn">
                          <h3 class="p-management-delete-title">ویرایش</h3>
                          <img class="p-management-salon-icon" src="../../assets/svg/edit.svg" alt="">
                        </button>
                    </div>

              </div>


      </div>

  </div>
</template>

<script>

export default {
  name: 'formData',
  components: {
  },

  props: {
    allSans  : {type:Array,default:[]},
  },

  data() {
    return {

    }
  },

  computed: {

  },

  watch: {

  },

  mounted () {

  },

  methods: {
    deleteSans(data){
      this.$emit('deleteSans',data)
    },

    editSans(data){
      this.$emit('editSans',data)
    },

  },

}
</script>
